export default __webpack_public_path__ + "static/media/add-button.22a76872.svg";